export default () => (
  /**
   * Botão "x" com cor cinza claro.
   * Responsável por fechar a tabela de atributos.
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.8592 5.67871)"
      stroke="#BDBCBC"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 5.37366 4.56445)"
      stroke="#BDBCBC"
      strokeWidth="1.5"
    />
  </svg>
);
